import { graphql } from "@/lib/gql/__generated__";

export const START_GUIDE_QUERY = graphql(/* GraphQL */ `
	query StartGuide($hotelID: ID!) {
		startGuide(hotelID: $hotelID) {
			id
			hotelID
			isHotelInfoRegistered
			isHotelPolicyRegistered
			isRoomRegistered
			isPlanRegistered
			isOptionRegistered
			isSiteControllerRegistered
			isPlainRegistered
			isCreditInfoRegistered
			isDepositAccountRegistered
			isBillingInfoRegistered
			isShowRoomPriceRank
			isRoomPriceRankRegistered
		}
	}
`);
